import React from "react";
import { newContextComponents } from "@drizzle/react-components";
import { Accordion, Card, Button, ProgressBar, Table } from 'react-bootstrap';

import { Web3StatusContext } from "../../contexts/Web3StatusContext";

const { AccountData, ContractData, ContractForm } = newContextComponents;
class WhitelistStatistics extends React.Component {
  static contextType = Web3StatusContext;

  state = {
    totalWhiteListedDataKey: null,
    totalWhiteListedCountDataKey: null,
  };

  componentDidMount() {
    const { drizzle } = this.props;
    const contract = drizzle.contracts.GAMEFORESTSale;

    const totalWhiteListedDataKey = contract.methods["totalWhiteListed"].cacheCall();
    const totalWhiteListedCountDataKey = contract.methods["totalWhiteListedCount"].cacheCall();
    
    this.setState({ totalWhiteListedDataKey, totalWhiteListedCountDataKey });
  }

  render() {
    // get the contract state from drizzleState
    const { GAMEFORESTSale } = this.props.drizzleState.contracts;

    var totalWhiteListedContract = GAMEFORESTSale["totalWhiteListed"][this.state.totalWhiteListedDataKey];
    var totalWhiteListedCountContract = GAMEFORESTSale["totalWhiteListedCount"][this.state.totalWhiteListedCountDataKey];
    var totalPlannedWei = 0;
    if(totalWhiteListedContract == undefined || totalWhiteListedCountContract == undefined)
    {
      return <div>Loading...</div>;
    }

    totalPlannedWei = this.context.web3.utils.fromWei(totalWhiteListedContract.value.toString(), "ether");

    return (
      <div>
        {totalWhiteListedCountContract.value} users registered for whitelisting
        <br/>
        total planned contribution: {totalPlannedWei}
      </div>
      
    );
  }
};

export default WhitelistStatistics;
